export default "__VITE_ASSET__56cfe215__"